import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/pages/home/components/Footer";
import { allArticleContents, type ArticleContent } from "@/mocks/articles";

const articleImages: Record<string, string> = {
  "article-polska-01": "https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20analytics%20dashboard%20warm%20sand%20colored%20desk%20surface%20soft%20morning%20light%20streaming%20through%20window%20clean%20editorial%20style%20professional%20atmosphere%20high%20detail%20no%20text%20no%20logos%20minimalist%20Nordic%20office%20setup%20with%20small%20plant%20and%20coffee%20cup&width=1200&height=630&seq=bp-polska-v2&orientation=landscape",
  "article-shoes-02": "https://readdy.ai/api/search-image?query=Artistic%20arrangement%20of%20three%20different%20stylish%20sneakers%20on%20a%20light%20terracotta%20ceramic%20surface%20soft%20afternoon%20sunlight%20casting%20long%20shadows%20clean%20editorial%20fashion%20photography%20warm%20earthy%20tones%20high%20detail%20creative%20composition%20no%20text%20no%20logos&width=1200&height=630&seq=bp-shoes-v2&orientation=landscape",
  "article-clothing-03": "https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20folded%20neutral%20toned%20clothing%20items%20on%20soft%20linen%20textured%20surface%20gentle%20morning%20light%20clean%20editorial%20aesthetic%20warm%20beige%20background%20high%20detail%20harmonious%20composition%20no%20text%20no%20logos%20Scandinavian%20minimalist%20style&width=1200&height=630&seq=bp-clothing-v2&orientation=landscape",
  "article-yupoo-04": "https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20fashion%20product%20gallery%20grid%20on%20a%20warm%20oat%20colored%20wooden%20table%20natural%20daylight%20from%20side%20window%20clean%20editorial%20photography%20modern%20lifestyle%20scene%20high%20detail%20no%20text%20no%20logos%20minimalist%20setup&width=1200&height=630&seq=bp-yupoo-v2&orientation=landscape",
  "article-shipping-05": "https://readdy.ai/api/search-image?query=Cardboard%20parcel%20box%20with%20shipping%20labels%20placed%20on%20a%20light%20sage%20green%20surface%20next%20to%20a%20small%20plant%20soft%20natural%20daylight%20clean%20editorial%20product%20photography%20warm%20tones%20high%20detail%20minimalist%20composition%20no%20text&width=1200&height=630&seq=bp-shipping-v2&orientation=landscape",
  "article-safe-06": "https://readdy.ai/api/search-image?query=Close%20up%20of%20padlock%20and%20shield%20symbol%20on%20a%20warm%20ivory%20paper%20textured%20surface%20soft%20natural%20lighting%20clean%20editorial%20style%20security%20concept%20high%20detail%20minimalist%20composition%20no%20text%20no%20logos%20professional%20atmosphere&width=1200&height=630&seq=bp-safe-v2&orientation=landscape",
  "article-sneakers-07": "https://readdy.ai/api/search-image?query=Five%20pairs%20of%20colorful%20stylish%20sneakers%20lined%20up%20on%20a%20warm%20sand%20colored%20concrete%20floor%20golden%20afternoon%20light%20casting%20dramatic%20shadows%20editorial%20fashion%20photography%20high%20detail%20creative%20composition%20no%20text%20no%20logos&width=1200&height=630&seq=bp-sneakers-v2&orientation=landscape",
  "article-nike-08": "https://readdy.ai/api/search-image?query=Nike%20sneakers%20displayed%20on%20a%20minimalist%20pale%20blush%20colored%20pedestal%20with%20soft%20studio%20lighting%20clean%20product%20photography%20high%20detail%20editorial%20fashion%20style%20warm%20neutral%20background%20no%20text%20no%20logos%20elegant%20composition&width=1200&height=630&seq=bp-nike-v2&orientation=landscape",
  "article-adidas-09": "https://readdy.ai/api/search-image?query=Adidas%20originals%20sneakers%20on%20a%20warm%20clay%20textured%20surface%20with%20soft%20afternoon%20lighting%20clean%20editorial%20product%20photography%20three%20different%20colorways%20displayed%20creatively%20high%20detail%20no%20text%20no%20logos%20fashion%20aesthetic&width=1200&height=630&seq=bp-adidas-v2&orientation=landscape",
  "article-finds-10": "https://readdy.ai/api/search-image?query=Curated%20collection%20of%20fashion%20items%20including%20sunglasses%20watch%20and%20accessories%20scattered%20artistically%20on%20a%20warm%20honey%20colored%20surface%20soft%20golden%20hour%20light%20editorial%20photography%20high%20detail%20no%20text%20no%20logos%20lifestyle%20composition&width=1200&height=630&seq=bp-finds-v2&orientation=landscape",
  "article-jackets-11": "https://readdy.ai/api/search-image?query=Two%20stylish%20outerwear%20jackets%20draped%20over%20a%20minimalist%20wooden%20chair%20in%20a%20bright%20airy%20room%20soft%20natural%20light%20from%20large%20window%20editorial%20fashion%20photography%20warm%20neutral%20tones%20high%20detail%20no%20text%20no%20logos&width=1200&height=630&seq=bp-jackets-v2&orientation=landscape",
  "article-accessories-12": "https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20fashion%20accessories%20including%20silver%20jewelry%20leather%20watch%20and%20sunglasses%20on%20a%20pale%20sand%20colored%20linen%20cloth%20soft%20diffused%20lighting%20editorial%20photography%20high%20detail%20luxurious%20composition%20no%20text%20no%20logos&width=1200&height=630&seq=bp-accessories-v2&orientation=landscape",
};

export default function BlogPost() {
  const location = useLocation();
  const [openFaq, setOpenFaq] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const slug = location.pathname.split("/").pop() || "";
  const article: ArticleContent | undefined = allArticleContents[slug];

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-20 min-h-screen flex items-center justify-center">
          <p className="text-foreground-500">Artykuł nie został znaleziony.</p>
        </main>
        <Footer />
      </>
    );
  }

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": article.faq.map((item) => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer,
      },
    })),
  };

  const siteUrl = import.meta.env.VITE_SITE_URL || "https://kakobuy.courses";
  const articleUrl = `${siteUrl}/blog/${article.slug}`;

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.title,
    "description": article.description,
    "image": articleImages[article.imageSeq],
    "author": {
      "@type": "Person",
      "name": "Adam Kowalski",
    },
    "publisher": {
      "@type": "Organization",
      "name": "Kakobuy Courses",
      "url": siteUrl,
    },
    "url": articleUrl,
    "datePublished": article.datePublished,
    "dateModified": article.datePublished,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": articleUrl,
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Strona główna",
        "item": siteUrl,
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Blog",
        "item": siteUrl,
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": article.title,
        "item": articleUrl,
      },
    ],
  };

  const relatedArticles = Object.values(allArticleContents)
    .filter((a) => a.slug !== article.slug)
    .slice(0, 3);

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <nav aria-label="Breadcrumb" className="bg-white border-b border-background-200">
          <div className="max-w-4xl mx-auto px-6 py-3">
            <ol className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
              <li>
                <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">
                  Strona główna
                </Link>
              </li>
              <li className="text-foreground-300">/</li>
              <li>
                <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">
                  Blog
                </Link>
              </li>
              <li className="text-foreground-300">/</li>
              <li className="text-foreground-700 font-medium truncate max-w-[200px]">{article.title}</li>
            </ol>
          </div>
        </nav>

        <header className="bg-white py-12 md:py-16">
          <div className="max-w-3xl mx-auto px-6">
            <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-600 bg-primary-50 rounded-full mb-4">
              Kakobuy Spreadsheet
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              {article.title}
            </h1>
            <div className="mt-8 flex items-center gap-4">
              <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20European%20man%20in%20his%20thirties%20with%20warm%20friendly%20expression%20soft%20studio%20lighting%20on%20a%20pale%20sage%20green%20backdrop%20minimalist%20editorial%20style%20high%20quality%20photography&width=100&height=100&seq=author-avatar-v2&orientation=squarish"
                  alt="Adam Kowalski"
                  title="Adam Kowalski – Specjalista ds. zakupów online Kakobuy Spreadsheet"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900">Adam Kowalski</p>
                <p className="text-xs text-foreground-500">
                  Specjalista ds. zakupów online · 5+ lat doświadczenia · Aktualizacja: 21 czerwca 2026
                </p>
              </div>
            </div>
          </div>
        </header>

        <article className="bg-white pb-12">
          <div className="max-w-3xl mx-auto px-6">
            <p
              className="text-base md:text-lg text-foreground-700 leading-relaxed mb-8"
              dangerouslySetInnerHTML={{ __html: article.sections.intro_html }}
            />

            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-10 mb-4">
              {article.sections.h2_1}
            </h2>
            <p
              className="text-base text-foreground-700 leading-relaxed mb-6"
              dangerouslySetInnerHTML={{ __html: article.sections.p1_html }}
            />

            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-10 mb-4">
              {article.sections.h2_2}
            </h2>
            <p
              className="text-base text-foreground-700 leading-relaxed mb-6"
              dangerouslySetInnerHTML={{ __html: article.sections.p2_html }}
            />

            <div className="my-10 overflow-x-auto">
              <table className="w-full text-sm border-collapse rounded-xl overflow-hidden">
                <thead>
                  <tr className="bg-foreground-800 text-foreground-50">
                    <th className="px-5 py-3.5 text-left font-semibold">Kryterium</th>
                    <th className="px-5 py-3.5 text-left font-semibold">Kakobuy Spreadsheet</th>
                    <th className="px-5 py-3.5 text-left font-semibold">Inne platformy</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="bg-background-100 border-b border-background-200">
                    <td className="px-5 py-3 text-foreground-700">Aktualizacje</td>
                    <td className="px-5 py-3 text-accent-600 font-semibold">Cotygodniowe</td>
                    <td className="px-5 py-3 text-foreground-500">Rzadkie</td>
                  </tr>
                  <tr className="bg-white border-b border-background-200">
                    <td className="px-5 py-3 text-foreground-700">Weryfikacja linków</td>
                    <td className="px-5 py-3 text-accent-600 font-semibold">Ręczna, 100%</td>
                    <td className="px-5 py-3 text-foreground-500">Automatyczna</td>
                  </tr>
                  <tr className="bg-background-100 border-b border-background-200">
                    <td className="px-5 py-3 text-foreground-700">Liczba produktów</td>
                    <td className="px-5 py-3 text-accent-600 font-semibold">500+</td>
                    <td className="px-5 py-3 text-foreground-500">100-200</td>
                  </tr>
                  <tr className="bg-white">
                    <td className="px-5 py-3 text-foreground-700">Kategorie</td>
                    <td className="px-5 py-3 text-accent-600 font-semibold">14+</td>
                    <td className="px-5 py-3 text-foreground-500">5-8</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-10 mb-4">
              {article.sections.h2_3}
            </h2>
            <p
              className="text-base text-foreground-700 leading-relaxed mb-6"
              dangerouslySetInnerHTML={{ __html: article.sections.p3_html }}
            />

            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-10 mb-4">
              {article.sections.h2_4}
            </h2>
            <p
              className="text-base text-foreground-700 leading-relaxed mb-6"
              dangerouslySetInnerHTML={{ __html: article.sections.p4_html }}
            />

            <div className="my-10 p-6 md:p-8 bg-primary-50 rounded-2xl border border-primary-100 text-center">
              <p className="text-base md:text-lg font-semibold text-foreground-900 mb-4">
                {article.sections.cta_text}
              </p>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-8 py-3 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>Odwiedź pełny Kakobuy Spreadsheet</span>
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>
        </article>

        <section className="py-12 bg-background-50">
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-8 text-center">
              Najczęściej zadawane pytania
            </h2>
            <div className="space-y-3">
              {article.faq.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl border border-background-200 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === index ? -1 : index)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-50 transition-colors cursor-pointer"
                  >
                    <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                      {item.question}
                    </span>
                    <i
                      className={`ri-arrow-down-s-line text-foreground-500 w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${
                        openFaq === index ? "rotate-180" : ""
                      }`}
                    ></i>
                  </button>
                  {openFaq === index && (
                    <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                Powiązane artykuły
              </h2>
              <p className="mt-2 text-sm text-foreground-500">
                Więcej o Kakobuy Spreadsheet
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {relatedArticles.map((related) => (
                <Link
                  key={related.slug}
                  to={`/blog/${related.slug}`}
                  className="group block bg-white rounded-2xl overflow-hidden transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={articleImages[related.imageSeq]}
                      alt={related.title}
                      title={related.title + " – Kakobuy Spreadsheet"}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                      {related.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-500">{related.description}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
        />
      </main>
      <Footer />
    </>
  );
}